import React, { useState, useEffect } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./blogPageStyles.css";
import { Link, Navigate, useNavigate } from "react-router-dom";

// BlogCard component remains the same (as in your code above)
const BlogCard = ({ user, avatarColor, timestamp, category, title, path, content, fullContent, upvotes, imageUrl, onClick }) => {
  const [timeAgo, setTimeAgo] = useState('');
   const navigate = useNavigate(); 

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const seconds = Math.floor((now - new Date(timestamp)) / 1000);
    if (seconds < 60) return 'just now';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    const days = Math.floor(hours / 24);
    return `${days} day${days !== 1 ? 's' : ''} ago`;
  };

  useEffect(() => {
    const update = () => setTimeAgo(getTimeAgo(timestamp));
    update();
    const interval = setInterval(update, 60000);
    return () => clearInterval(interval);
  }, [timestamp]);

    const handleClick = () => {
    navigate(path); 
  };

  const styles = {
    card: {
      backgroundColor: '#ffffff',
      color: '#000',
      padding: '20px',
      marginBottom: '20px',
      borderRadius: '12px',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
      width: '100%',
      maxWidth: '100%',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
    },
    avatar: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: avatarColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 'bold',
      fontSize: '18px',
      color: '#fff',
      marginRight: '10px',
    },
    userInfo: {
      fontSize: '13px',
      color: '#666',
    },
    title: {
      fontSize: '32px',
      fontWeight: 'bold',
      margin: '10px 0 5px',
    },
    content: {
      fontSize: '15px',
      color: '#212121',
      marginBottom: '15px',
    },
    actions: {
      display: 'flex',
      gap: '12px',
      marginBottom: '15px',
    },
    button: {
      background: '#f0f0f0',
      color: '#333',
      border: '1px solid #ccc',
      padding: '6px 12px',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '14px',
    },
    comment: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    commentAvatar: {
      width: '30px',
      height: '30px',
      background: '#b5fff3',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#000',
      fontWeight: 'bold',
    },
    commentInput: {
      flex: 1,
      background: '#f9f9f9',
      color: '#000',
      border: '1px solid #ccc',
      padding: '8px 12px',
      borderRadius: '8px',
      fontSize: '14px',
    },
  };

  

  return (
    <div onClick={handleClick} style={styles.card}>
      <div style={styles.title}>{title}</div>
      {imageUrl && (
           <img
             src={imageUrl}
             alt={title}
             style={{
               width: '500px',
               maxHeight: '500px',
               objectFit: 'cover',
               borderRadius: '8px',
               margin: '10px 0',
             }}
           />
         )}
      <div style={styles.content}>
        {content}
        <span style={{ color: '#999' }}>... (click to read more)</span>
      </div>
        <div style={styles.userInfo}>
         {timeAgo} • Posted {category}
        </div>

      {/* <div style={styles.actions} onClick={(e) => e.stopPropagation()}>
        <button style={styles.button}>↑ {upvotes > 0 ? upvotes : ''}</button>
        <button style={styles.button}>🔖 Follow</button>
        <button style={styles.button}>🔗 Share</button>
      </div> */}
      {/* <div style={styles.comment} onClick={(e) => e.stopPropagation()}>
        <div style={styles.commentAvatar}>G</div>
        <input
          style={styles.commentInput}
          type="text"
          placeholder="What are your thoughts?"
        />
      </div> */}
      
    </div>
  );
};

// BlogPage component
const BlogPage = () => {
  

  const blogs = [
    {
      id: 'antenatal',
      // user: 'Ruchika',
      avatarColor: '#7c4dff',
      timestamp: new Date('2025-06-04T09:00:00'),
      // category: 'Ask Your Doctor',
      title: "Antenatal Care in Pregnancy: What It Is & Why It Matters",
      imageUrl: '/Blog1.png',
      content: "Let’s learn why prenatal care matters—from early risk detection to emotional support. Read how integrated care ensures a safe, healthy pregnancy journey.",
      upvotes: 0,
      path: "/antenatal-care-what-it-is-and-why-it-matters",

    },

    {
      id: 'FirstTrimester',
      // user: 'Sweta',
      avatarColor: '#2196f3',
      timestamp: new Date('2025-06-07T09:00:00'),
      // category: 'Ask Your Doctor',
      title: 'First Trimester of Pregnancy: What to Expect & Tips',
      imageUrl: '/Blog2.png',
      content: 'First trimester? Learn about early pregnancy signs, essential scans, nutrition, and mental wellbeing for a healthy and stress-free start. Read the full blog!',
      upvotes: 1,
      path: "/first-trimester-guide-what-to-expect",
    },

    {
      id: 'firsttrimestersymptoms,',
      // user: 'Sweta',
      avatarColor: '#2196f3',
      timestamp: new Date('2025-06-30T09:00:00'),
      // category: 'Ask Your Doctor',
      title: 'Your Guide to First Trimester Symptoms - Myprega',
      imageUrl: '/Blog3.png',
      content: 'Find out common first-trimester symptoms, what they mean, and how to manage them. A must-read guide for moms-to-be navigating early pregnancy changes.',
      upvotes: 2,
      path: "/first-trimester-symptoms-for-moms",
    },
        {
      id: 'PregnancyDietPlan,',
      // user: 'Sweta',
      avatarColor: '#2196f3',
      timestamp: new Date('2025-07-19T09:00:00'),
      // category: 'Ask Your Doctor',
      title: 'Pregnancy Diet Plan: What to Eat & Avoid During Pregnancy',
      imageUrl: '/Blog4.png',
      content: 'Find out what to eat and avoid during pregnancy, trimester by trimester. Support your baby’s development with smart food choices. Read the full blog!',
      upvotes: 3,
      path: "/pregnancy-diet-plan-guide",
    },

    {
      id: 'PregnancyComplicationsExplained,',
      // user: 'Sweta',
      avatarColor: '#2196f3',
      timestamp: new Date('2025-08-23T09:00:00'),
      // category: 'Ask Your Doctor',
      title: 'Most Common Pregnancy Complications Explained',
      imageUrl: '/Blog5.png',
      content: 'Learn about common pregnancy complications, warning signs,and prevention strategies. Daily health tracking is your secret to a safe delivery.',
      upvotes: 4,
      path: "/understanding-most-common-pregnancy-complications",
    },

    // add more blogs here
  ];

  return (
    <div style={{ background: '#f9f9f9', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />

      <div
        style={{
          padding: '20px',
          paddingTop: '60px',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          flexGrow: 1,
        }}
      >
        {/* Hero Section */}
        <div style={{
          background: '#fff8ef',
          padding: '60px 20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          maxWidth: '100%',
          margin: '0 auto',
          borderRadius: '12px',
        }}>
          <div style={{ flex: '1', minWidth: '300px', paddingRight: '20px' }}>
            <h1 style={{ fontSize: '38px', color: '#e91e63' }}>
              Expert Pregnancy Blogs, Backed by Doctors
            </h1>
            <p style={{ fontSize: '20px', color: '#333', marginTop: '20px' }}>
              Your reliable resource for every week of your Pregnancy journey 🤰📚
            </p>
            <p style={{ fontSize: '20px', color: '#333', marginTop: '20px' }}>
              Explore doctor-reviewed blogs crafted by medical experts to give you clear, accurate, 
              and reliable information on everything pregnancy. Whether you're in your first trimester or nearing delivery, 
              Myprega’s library is your go-to place for answers, care tips, and peace of mind—backed by science and compassion.
            </p>
          </div>

          <div className="col-md-6 order-mobile">
            <img src="/Blogpageheroimage.gif" alt="not found" />
          </div>
        </div>

        {/* Blog Cards Grid */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '20px',
            width: '100%',
            marginTop: '40px',
          }}
        >
          {blogs.map((blog) => (
            <div
              key={blog.id}
              style={{
                flex: '1 1 calc(33.33% - 40px)',
                maxWidth: 'calc(33.33% - 40px)',
                minWidth: '300px',
              }}
            >
              <BlogCard {...blog} />
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: 'auto' }}>
        <Footer />
      </div>
    </div>
  );
};

export default BlogPage;